import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import loadBudget from '../utils/loadBudget'
import BudgetInputManager from '.'

const mapStateToProps = (state, props) => ({
  budget: loadBudget({ state, id: props.modelId, context: props.context }),
  parentBudget: loadBudget({
    state,
    id: props.parentId,
    context: props.parentContext,
  }),
})

const mapDispatchToProps = (dispatch) => ({
  createBudget: (options) => {
    dispatch(actions.createBudget(options))
  },
  getBudget: (options) => {
    dispatch(actions.getBudget(options))
  },
  updateBudget: (options) => {
    dispatch(actions.updateBudget(options))
  },
})

const ConnectedBudgetInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(BudgetInputManager)

export default ConnectedBudgetInput
